import React, { Component, PropTypes } from 'react'
import CSSModules from 'react-css-modules'
import Styles from './FamilyGrid.css'
import {Row, Col} from 'react-flexbox-grid'
import format from '../../helpers/format'
import analytics from '../../helpers/analytics'
import config from '../../config'
import { Link, LinkIcon } from '../../components'
// import convert from '../../helpers/convert'

@CSSModules(Styles)
export default class FamilyGrid extends Component {
  static propTypes = {
    fullGrid: PropTypes.bool
  }
  constructor(props){
    super(props)
  }
  onMouseEnter = (prop) => {
    return () => {
      // this.state.onHovers[prop] = true
      const onHovers = Object.assign({},this.state.onHovers)
      onHovers[prop] = true
      this.setState({onHovers: onHovers})
      // console.log('enter:',onHovers )
    }
  }

  onMouseLeave = (prop) => {
    return () => {
      const onHovers = Object.assign({},this.state.onHovers)
      delete onHovers[prop]
      this.setState({onHovers: onHovers})
      // console.log('leave:',onHovers )
      // console.log('leave:',this.state.onHovers )
    }
  }

  renderCompanies = () => {
    return config.familyFunds.map((c,idx) =>{
      return this.renderCompany(idx, c)
    })
  }

  renderLogo = (title) => {
    const fileName = format.imgPath(title)
    let hasLogo = false
    let companyLogo = null
    try {
      companyLogo = require('../../../static/images/fam/'+fileName+'.png')
      hasLogo = true
    }
    catch (e) {
      console.log('')
    }
    if (hasLogo) {
      return (
        <img
          styleName='box-title-logo'
          src={companyLogo}
          alt={title}
        />
      )
    } else {
      console.log(fileName)
      return (
        <span>{title}</span>
      )
    }
  }

  renderCompany = (idx, c) => {
    const { fund_family_name, sri, gef_num_funds, gef_score_norm, net_assets } = c
    const safeName = encodeURIComponent(fund_family_name)
    return(
      <Col key={idx} styleName='companies-box-wrap' xs={12} sm={4}>
        <Link
          onMouseEnter={this.onMouseEnter('company-'+idx)}
          onMouseLeave={this.onMouseLeave('company-'+idx)}
          log={analytics.eventToFamily(fund_family_name)}
          to={config.routes.families+'?q='+safeName}
          styleName='companies-link'
          title={fund_family_name}
        >
          <div styleName='companies-box'>
            <div styleName='box-title-wrapper'>
              { this.renderLogo(fund_family_name) }
            </div>
            <div styleName='box-subtitle'>
              Funds rated: <strong>{gef_num_funds}</strong>
            </div>
            { /* <div styleName='box-subtitle'>
              Fund assets analyzed, USD: <strong>{format.money(net_assets,true,'USD',true,1)}</strong>
            </div> */ }
            { /* <div styleName='box-subtitle'>
              &mdash;
            </div> */ }
            { /* <div styleName='box-subtitle'>
               Sustainable funds: <strong>{sri}</strong>
            </div> */ }
            <div styleName='box-subtitle'>
              Average fund score:  <strong>{Math.round(gef_score_norm).toFixed(0)}</strong> / 100
            </div>
            <div styleName='learn-more-wrap'>
              <div styleName='learn-more'>
                More <i className='fa fa-angle-double-right'/>
              </div>
            </div>
          </div>
        </Link>
      </Col>
    )
  }

  renderAddtl = () => {
    if (!this.props.fullGrid) {
      return null
    }

    const allFams = config.formOptions.fundFamilyAll
    const filteredFams = allFams.reduce((arr, el) => {
      if (el.name !== 'All funds') {
        arr.push(el)
      }
      return arr
    }, [])

    return (
      <div>
        <div styleName='addtl-fam-info'>
          <strong>
            We analyze funds from over one hundred asset managers.
            &nbsp;
            See the full list below:
          </strong>
        </div>
        <div styleName='addtl-fam-links'>
          { filteredFams.map( (el, ix) => {
            return (
              <Link
                to={config.routes.families+'?q='+el.name}
                title={el.name}
                key={el.name}
                strong={true}
              >
                <div styleName='addtl-fam-link'>

                  <div styleName='addtl-fam-link-logo'>
                    { this.renderLogo(el.name, el.name) }
                  </div>

                  <div styleName='addtl-fam-link-lbl'>
                    { el.name }<LinkIcon />
                  </div>

                </div>
              </Link>
            )
          }) }
        </div>
      </div>
    )
  }

  render() {
    return (
      <div styleName='companies'>
        <div styleName='companies-anchor' id='companies'/>
        <div styleName='companies-inner'>
          <div styleName='companies-title'>
            Are fund managers investing in gender equality?
          </div>
          <div styleName='companies-info'>
            Are your savings invested with one of these financial giants?
            <br/>
            Click through and find out how the mutual funds they offer stack up.
          </div>
          <Row styleName='companies-boxes'>
            { this.renderCompanies() }
          </Row>
          { this.renderAddtl() }
        </div>
      </div>
    )
  }
}
